import React from 'react';
import './SecondaryCtaSection.css';

const SecondaryCtaSection: React.FC = () => {
  return (
    <section className="secondary-cta-section">
      <h2>Ready to Transform Your Operations?</h2>
      <p>Experience the power of intelligent checklists. Start your free trial today and take your business to the next level.</p>
      <button className="cta-button" onClick={() => window.open('https://app.checkifai.nl/', '_blank')}>Start Your Free Trial</button>
    </section>
  );
};

export default SecondaryCtaSection;
